// extracted by mini-css-extract-plugin
module.exports = {"controls":"style__controls__idhI1","submit":"style__submit__1sEnS","projects":"style__projects__DSWL3"};